// extracted by mini-css-extract-plugin
export default {"container":"AssetItemInfo_container__85jTV","divider":"AssetItemInfo_divider__QR-t4","extraClassname":"AssetItemInfo_extraClassname__YOvyH"};